import React, { useState, useEffect } from "react";
import "./NavBar.css";
import { Menu, Drawer } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useLocation, useNavigate } from "react-router-dom";

import { MenuInfo as ClickParam } from "rc-menu/lib/interface";
import { useTranslation } from "react-i18next";
import logo from "assets/flexi-logo.png";

function LoggedOutNavbar() {
  const location = useLocation();
  const navigate = useNavigate();

  const [route, setRoute] = useState("");
  const [drawerVisible, setDrawerVisible] = useState(false);
  const { t } = useTranslation("navbar");

  useEffect(() => {
    // get rid of the "/" in the pathname using slice
    const pathname: string = location.pathname.split("/")[1];
    // update route state
    setRoute(pathname !== "" ? pathname : "register");
    // Update metadata title
    // The convention here is that pathname will be kebab-case (i.e. my-classes)
    // Therefore first get individual parts of the phrase then capitalize 1st letter of each word
    if (pathname !== "") {
      const words = pathname.split("-");
      let title = "LTL Flexi Classes - ";
      words.forEach((word: string) => {
        title += `${word[0].toUpperCase() + word.slice(1)} `;
      });
      document.title = title;
    }
  }, [location.pathname]);

  const onNavBarMenu = (params: ClickParam) => {
    const { key, keyPath } = params;

    if (key === "language-switcher") return;

    const newRoute = key;
    /* Every menu tab will have a keyPath property, which is an array.
      The first element of this array will be the key of the tab itself.
      The second element of this array (if it exists) is the key of the parent tab
      (in the case of using a submenu)
    */
    // if it's the normal menu
    if (keyPath.length === 1) {
      if (newRoute === "account") {
        // do nothing when click on profile item
      } else if (newRoute === "register") {
        window.location.href = "https://flexiclasses.com";
      } else {
        navigate(`/${newRoute}`);
      }
      // else if it's the submenu in the mobile nav
    } else if (keyPath.length === 2) {
      // right now do nothing
    }
  };

  const renderLogo = () => <img className="logo" src={logo} alt="ltl-logo" />;

  const NavbarItems = [
    <Menu.Item className="nav-tab" key="register">
      {t("Register").toLocaleUpperCase()}
    </Menu.Item>,
    <Menu.Item className="nav-tab" key="login">
      {t("Login").toLocaleUpperCase()}
    </Menu.Item>,
  ];

  const renderDesktopNavbarMenu = () => (
    <Menu
      className="navbar"
      theme="light"
      mode="horizontal"
      onClick={onNavBarMenu}
      selectedKeys={[route]}
    >
      {NavbarItems}
    </Menu>
  );
  const renderMobileNavbarMenu = () => (
    <Drawer
      placement="left"
      closable={false}
      onClose={() => {
        setDrawerVisible(false);
      }}
      visible={drawerVisible}
    >
      <Menu
        className="mobile-navbar"
        id="navbar"
        theme="light"
        mode="inline"
        onClick={onNavBarMenu}
        selectedKeys={[route]}
      >
        {NavbarItems}
      </Menu>
    </Drawer>
  );

  const renderNavbar = () => {
    // if already signed in, 2 cases
    // for desktop:
    if (window.matchMedia("(min-width: 800px)").matches) {
      return (
        <>
          {renderLogo()}
          {renderDesktopNavbarMenu()}
        </>
      );
    }
    // for mobile
    return (
      <>
        <div className="icon-logo-container">
          <div className="menu-icon-container">
            <FontAwesomeIcon
              icon={faBars as IconProp}
              className="menu-icon"
              size="2x"
              onClick={() => {
                setDrawerVisible(true);
              }}
            />
          </div>
          {renderLogo()}
        </div>
        {renderMobileNavbarMenu()}
      </>
    );
  };

  return renderNavbar();
}

export default LoggedOutNavbar;
